import { safeClientCallback } from '@/modules/server/helpers-client';

export const checkStandalone = safeClientCallback(
  () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true,
  false
);

export const trackStandaloneChange = (
  callback: (isStandalone: boolean) => void
) => {
  callback(checkStandalone());

  const mediaQuery = window.matchMedia('(display-mode: standalone)');
  const handler = (event: MediaQueryListEvent) => {
    callback(event.matches || (window.navigator as any).standalone === true);
  };
  mediaQuery.addEventListener('change', handler);

  const iosHandler = () => {
    callback(checkStandalone());
  };
  document.addEventListener('visibilitychange', iosHandler);
  window.addEventListener('focus', iosHandler);

  return () => {
    mediaQuery.removeEventListener('change', handler);
    document.removeEventListener('visibilitychange', iosHandler);
    window.removeEventListener('focus', iosHandler);
  };
};
